import http from "@/api";
import { RequestRes } from "@/api/type";

// 获取衣服分类列表
export const getGarmentTypeList = ()=>{
    return http.get('/api/garmentType/list').then(res=>{
        return res
    }) as Promise<RequestRes>
}
// 获取衣服列表
export const getGarmentList = (typeId:string)=>{
    return http.get('/api/garment/list',{params:{type:typeId}}).then(res=>{
        return res
    }) as Promise<RequestRes>
}
